import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "11",
  viewBox: "0 0 14 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "Group 1037" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path 891",
    d: "M8.40521 0.198242L13.4845 5.34673V5.87539L8.40521 11.0004L7.21009 9.80558L9.66924 7.27722C9.99119 6.97844 10.29 6.79459 10.6805 6.58758V6.49581H0.515625L0.515625 4.67996H10.6805V4.58819C10.2208 4.40435 9.99119 4.22051 9.66924 3.89855L7.21009 1.39337L8.40521 0.198242Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }